// directives/fadeInOnScroll.ts
import type { Directive } from "vue";

interface AnimateItem {
  el: HTMLElement;
  top: number;
  left: number;
  animated?: boolean;
}

const fadeInOnScroll: Directive = {
  beforeMount(el, binding) {
    console.log(binding, "value");
    let heightVal = binding.arg === "height" ? binding.value : 120;
    el.style.opacity = "0";
    el.style.transform = `translateY(${heightVal}px)`;
    el.style.transition = "opacity 0.8s ease, transform 0.8s ease";
    el.classList.add("fw-scroll-in-ready");

    // 延迟执行，等页面渲染完
    setTimeout(() => {
      const allElements = Array.from(
        document.querySelectorAll(".fw-scroll-in-ready")
      ) as HTMLElement[];
      const screenHeight = window.innerHeight;

      // ===== 👇 处理首屏动画逻辑 =====
      const initialVisibleItems: AnimateItem[] = allElements
        .map((el) => {
          const rect = el.getBoundingClientRect();
          return { el, top: rect.top, left: rect.left };
        })
        .filter((item) => item.top < screenHeight + 120);

      // 按 top -> left 排序
      initialVisibleItems.sort((a, b) => {
        if (a.top !== b.top) return a.top - b.top;
        return a.left - b.left;
      });

      // 依次执行首屏动画
      initialVisibleItems.forEach((item, index) => {
        setTimeout(() => {
          item.el.style.opacity = "1";
          item.el.style.transform = "translateY(0)";
          item.el.classList.remove("fw-scroll-in-ready");
          item.animated = true;
        }, 500 + index * 200);
      });

      // ===== 👇 处理滚动进入动画逻辑 =====
      const observer = new IntersectionObserver(
        (entries) => {
          const toAnimate: AnimateItem[] = [];

          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const el = entry.target as HTMLElement;
              if (el.classList.contains("fw-scroll-in-ready")) {
                const rect = el.getBoundingClientRect();
                toAnimate.push({ el, top: rect.top, left: rect.left });
                observer.unobserve(el);
              }
            }
          });

          // 多个元素同时出现，也按顺序依次执行
          toAnimate.sort((a, b) => {
            if (a.top !== b.top) return a.top - b.top;
            return a.left - b.left;
          });

          toAnimate.forEach((item, index) => {
            setTimeout(() => {
              item.el.style.opacity = "1";
              item.el.style.transform = "translateY(0)";
              item.el.classList.remove("fw-scroll-in-ready");
            }, index * 150); // 每个间隔 150ms
          });
        },
        {
          threshold: 0.1,
          rootMargin: "0px 0px 0px 0px",
        }
      );

      // 对剩余未执行的元素添加 observer
      allElements.forEach((el) => {
        if (el.classList.contains("fw-scroll-in-ready")) {
          observer.observe(el);
        }
      });
    }, 0);
  },
};

export default fadeInOnScroll;
